import { createSlice } from "@reduxjs/toolkit";
import { STATES_NAMES } from "../../enums/Enums";

const commonInitialState = {
  isShowLoadingSpinner: false,
  isFirstTimeLoading: true,
  isOpenChangesExists: false,
  showScanFobButton: true, 
  showFobScannerInput: false, 
  showAssigneFobOptions: false, 
  showAddNewUserButton: false,
  showAdditionalParkingAllocationButton: true,
  assigneOption: null, 
  showExsistingParkingAllocation: false,
  isUsersDataFetching: false,
  messageModal: {
    isShowModal: false
  },
  tableModal: {
    isShowModal: false
  },
  sideModal: {
    isShowModal: false,
    modalContent: null,
    modalHeader: null,
    modalCloseMessage: null
  }
};

const commonSlice = createSlice({
  name: STATES_NAMES.COMMON,
  initialState: commonInitialState,
  reducers: {
    commonLogout(state) {
      state.isShowLoadingSpinner = false;
      state.isFirstTimeLoading = true;
      state.isOpenChangesExists = false;
      state.showScanFobButton = true;
      state.showFobScannerInput = false; 
      state.showAssigneFobOptions = false; 
      state.showAddNewUserButton = false;
      state.showAdditionalParkingAllocationButton = true;
      state.assigneOption = null;
      state.showExsistingParkingAllocation = false;
      state.isUsersDataFetching = false;
      state.messageModal.isShowModal = false;
      state.tableModal.isShowModal = false;
      state.sideModal.isShowModal = false;
      state.sideModal.modalContent = null;
      state.sideModal.modalHeader = null;
      state.sideModal.modalCloseMessage = null;
    },
    setIsShowLoadingSpinner(state, action) {
      state.isShowLoadingSpinner = action.payload;
      if (state.isShowLoadingSpinner === true) {
        state.messageModal.isShowModal = false;
        //state.tableModal.isShowModal = false;
      }
    },
    setMessageModal(state, action) {
      state.messageModal.isShowModal = true;
      state.messageModal = { ...state.messageModal, ...action.payload };
    },
    closeMessageModal(state) {
      state.messageModal.isShowModal = false;
    },
    setTableModal(state, action) {
      state.tableModal.isShowModal = true;
      state.tableModal = { ...state.tableModal, ...action.payload };
    },
    closeTableModal(state) {
      state.tableModal.isShowModal = false;
    },
    setSideModal(state, action) {
      state.sideModal.isShowModal = true;
      state.sideModal = { ...state.sideModal, ...action.payload };
    },
    closeSideModal(state) {
      state.sideModal.isShowModal = false;
      state.sideModal.modalContent = null;
      state.sideModal.modalHeader = null;
      state.sideModal.modalCloseMessage = null;
    },
    setIsFirstTimeLoading(state, action) {
      state.isFirstTimeLoading = action.payload;
    },
    setIsOpenChangesExists(state, action) {
      state.isOpenChangesExists = action.payload;
    },
    setShowScanFobButton(state, action) {
      state.showScanFobButton = action.payload;
    },
    setShowFobScannerInput(state, action) {
      state.showFobScannerInput = action.payload;
    },
    setShowAssigneFobOptions(state, action) {
      state.showAssigneFobOptions = action.payload;
    },
    setAssigneOption(state, action) {
      state.assigneOption = action.payload;
    },
    setShowExsistingParkingAllocation(state, action) {
      state.showExsistingParkingAllocation = action.payload;
    },
    setShowAddNewUserButton(state, action) {
      state.showAddNewUserButton = action.payload;
    },
    setShowAdditionalParkingAllocationButton(state, action) {
      state.showAdditionalParkingAllocationButton = action.payload;
    },
    setIsUsersDataFetching(state, action) {
      state.isUsersDataFetching = action.payload;
    }
  },
});

export const commonActions = commonSlice.actions;

export default commonSlice.reducer;
